import { useState, useContext } from 'react'
import Pagination from "../../../shared/Pagination";
import {
  IconButton, Skeleton
} from '@mui/material'
import {
  AddOutlined as AddOutlinedIcon,
  EditOutlined as EditOutlinedIcon
} from '@mui/icons-material'
import { useForm } from "react-hook-form";
import { Button } from "../../../form-controls";
import ClientForm from "./ClientForm";
import { useQuery } from "react-query"
import { FetchContext } from "../../../../context/FetchContext"
import apiResources from "../../../../api/api.constants"

const Clients = () => {
  const [page, setPage] = useState(1)
  const {
    register,
    handleSubmit,
  } = useForm()
  const [open, setOpen] = useState(false);
  const [initialData, setInitialData] = useState({});
  const { authFetch }: any = useContext(FetchContext)

  const getList = async (page: number = 1) => {
    const options = {
      range: {
        "page": page,
        "pageSize": 10
      }
    }
    const { data: response } = await authFetch.post(apiResources.getClients, options)
    return response
  }

  const list = useQuery(['clients', page], () => getList(page))

  const onSubmitFilter = (data: any) => console.log(data)


  const handleClickOpen = (item: any) => {
    setOpen(true)
    setInitialData(item)
  }

  const handleClose = (status = null) => {
    setOpen(false)
    if(status === 'updated') {
      list.refetch()
    }
  }


  return (
    <section className="listing-container mt-3">
      <form onSubmit={handleSubmit(onSubmitFilter)} autoComplete="off">
        <div className="listing-actions">
          <input className="form-control" {...register('searchSchool')} placeholder="Search for a client..." />
          <Button type='submit' className='ms-2'>Submit</Button>
          <Button onClick={handleClickOpen} className='ms-2' color='success' >
            <AddOutlinedIcon />
          </Button>
        </div>
      </form>

      <div className="table-responsive">
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col">Sno.</th>
              <th scope="col">Organization Name</th>
              <th scope="col">Address</th>
              <th scope="col">Status</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {list.isLoading ? (
              <tr>
                <td><Skeleton variant='text' /></td>
                <td><Skeleton variant='text' /></td>
                <td><Skeleton variant='text' /></td>
                <td><Skeleton variant='text' /></td>
                <td className='d-flex'>
                  <Skeleton variant='circular' width={24} height={24} />
                </td>
              </tr>
            ) : list.data?.data?.length ? (
              list.data?.data?.map((item: any, i: number) => (
                <tr key={item.id}>
                  <td>{i + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.address}</td>
                  <td className='text-capitalize'>{item.status}</td>
                  <td>
                    <IconButton title='Edit' size="small" onClick={() => handleClickOpen(item)}>
                      <EditOutlinedIcon fontSize='small' />
                    </IconButton>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5}>No Records Found...</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Pagination totalPages={list.data?.pageCount} onChange={setPage} />
      {open && <ClientForm open={open} handleClose={handleClose} initialData={initialData} />}
    </section>
  )
};

export default Clients;
